import Cookies from 'js-cookie'
import Link from 'next/link'
import { useRouter, withRouter } from 'next/router'
import React, { useEffect, useState } from 'react'

import { API_KEY_LINX } from '../../util/config'
import Carregando from '../carregando'
import Mascara from '../mascara'
import { ContainerResultados } from './styles'
import { IconMagnifyingGlass } from '@gazin/ecommerce-ui'
import { useGlobalContext } from 'src/contexto/contextoGlobal'
import { OriginLoadingEnum } from 'src/util/enums/origin-loading'

function ComponentePesquisa() {
  const [busca, setBusca] = useState('')
  const [loading, setLoading] = useState(false)
  const [mascara, setMascara] = useState(false)
  const [exibeResultados, setExibeResultados] = useState(false)
  const [resultados, setResultados] = useState(null)
  const [deviceId, setDeviceId] = useState('')

  const router = useRouter()
  const { originLoading, setOriginLoading } = useGlobalContext()

  useEffect(() => {
    buscarIdentificador()
    getStringBusca()
  }, [])

  useEffect(() => {
    listener()
  })

  useEffect(() => {
    setLoading(false)
  }, [router.query])

  const getStringBusca = async () => {
    const paramsURL = new URLSearchParams(router)
    const queryBusca = paramsURL.get('busca')
    setBusca('')

    if (queryBusca) {
      setBusca(queryBusca)
    }
  }

  const keyPressed = (event) => {
    return focusInput(event)
  }

  function focusInput(e) {
    if (e.key === 'Enter' && busca.trim() !== '') {
      e.currentTarget.blur()
      return pushBusca()
    }

    if (e.target.type !== 'text') return

    setMascara(true)
    setBusca(e.target.value)

    if (e.target.value == '') return maisBuscadas()

    if (e.target.value.length >= 3 && e.target.value != busca)
      return pesquisa(tratarTextoDeBusca(e.target.value))
  }

  function pushBusca() {
    setMascara(false)
    setOriginLoading(OriginLoadingEnum.SEARCH)
    router.push(
      '/busca/[...busca]',
      `/busca/${encodeURIComponent(tratarTextoDeBusca(busca.trim()))}`
    )
  }

  function tratarTextoDeBusca(texto) {
    // A regex enquadra qualquer % presente na busca
    return texto.replace(/%/g, '')
  }

  // Busca os termos mais pesquisados
  async function maisBuscadas() {
    // Pesquisa pelos termos na API
    await fetch(
      `https://api.linximpulse.com/engage/search/v3/autocompletes/popular?apikey=${API_KEY_LINX}${
        deviceId ? `&deviceId=${deviceId}` : ``
      }`
    ).then((response) => {
      // Se der erro na busca, não mostra a div com os termos
      if (!response.ok) return setExibeResultados(false)

      return response.json().then((data) => {
        if (data && data.queries && data.queries.length > 0) {
          setResultados(data.queries)

          // Se houver resultados exibe a div com os termos
          return setExibeResultados(true)
        }

        setExibeResultados(false)
      })
    })
  }

  // Busca termos através da query informada
  async function pesquisa(query) {
    // Pesquisa pelos termos na API
    await fetch(
      `https://api.linximpulse.com/engage/search/v3/autocompletes?apikey=${API_KEY_LINX}&prefix=${encodeURIComponent(
        query
      )}&resultsQueries=${7}&resultsProducts=${0}${
        deviceId ? `&deviceId=${deviceId}` : ``
      }`
    ).then((response) => {
      // Se der erro na busca, não mostra a div com os termos
      if (!response.ok) return setExibeResultados(false)

      return response.json().then((data) => {
        if (data && data.queries && data.queries.length > 0) {
          setResultados(data.queries)

          // Se houver resultados exibe a div com os termos
          return setExibeResultados(true)
        }

        setExibeResultados(false)
      })
    })
  }

  function listener() {
    const overlay = document.querySelector('.mascara')
    const componenteBusca = document.querySelector('.componente-busca')

    const fecharOpcao = () => {
      if (overlay) {
        setExibeResultados(false)
        setMascara(false)
      }
    }

    if (overlay && componenteBusca) {
      document.querySelector('.mascara').addEventListener('click', fecharOpcao)
    }
  }

  async function buscarIdentificador() {
    let device = ''

    if (Cookies.get('nav_id')) device = Cookies.get('nav_id')

    await setDeviceId(device)
  }

  return (
    <>
      {loading && <Carregando />}
      <Mascara className="mascara" active={mascara ? true : false} />

      <div
        className={`search componente-busca ${mascara ? 'sobrepor' : ''}`}
        onFocus={(e) => focusInput(e)}
        style={{ zIndex: 20 }}
      >
        <div className="controls">
          <input
            type="text"
            name="busca"
            placeholder="O que você procura?"
            required
            onChange={(e) => {
              focusInput(e)
              // setBusca(e.target.value)
            }}
            onKeyPress={(e) => keyPressed(e)}
            value={busca}
            autoComplete="off"
          />

          <button aria-label="Buscar">
            {busca.trim() !== '' ? (
              <Link
                href="/busca/[...busca]"
                as={`/busca/${encodeURIComponent(busca.trim())}`}
                onClick={pushBusca}
              >
                <IconMagnifyingGlass
                  width="1.1875rem"
                  height="1.1875rem"
                  color="#fff"
                />
              </Link>
            ) : (
              <a>
                <IconMagnifyingGlass
                  width="1.1875rem"
                  height="1.1875rem"
                  color="#fff"
                />
              </a>
            )}
          </button>
        </div>

        <ContainerResultados
          active={exibeResultados && mascara ? exibeResultados : false}
        >
          <ul>
            {resultados &&
              resultados.map((termo, chave) => {
                if (chave < 8) {
                  return (
                    <Link
                      href={`/busca/[...busca]`}
                      as={`/busca/${termo.query}`}
                      key={termo.query}
                      onClick={(e) => {
                        setLoading(true)
                        setMascara(false)
                        setOriginLoading(OriginLoadingEnum.SEARCH)
                      }}
                    >
                      <li>{termo.query}</li>
                    </Link>
                  )
                }
              })}
          </ul>
        </ContainerResultados>
      </div>
    </>
  )
}

export default withRouter(ComponentePesquisa)
